import React from 'react';
import { useNavigate } from 'react-router-dom';
import Grid from '@mui/material/Grid';
import Link from '@mui/material/Link';
import CardItem from 'components/CardItem';
import Card from 'components/Card';

export default function CardTag(props) {
  const navigate = useNavigate();

  function tagDetail() {
    navigate(`/tag/${props.tag.id}/${props.tag.name}`);
  }

  return (
    <Grid container>
      <Grid item lg={6} md={6} xs={12}>
        <Card
          bordered
          style={{
            marginTop: '10px',
          }}
        >
          <Grid
            alignItems="center"
            style={{
              padding: '0px',
              width: '520px',
              maxWidth: '100%',
            }}
          >
            <Grid item xs={12}>
              <Grid
                container
                alignItems="center"
                justifyContent="space-between"
                style={{
                  padding: '14px 18px',
                  gap: '16px',
                }}
              >
                <Grid item xs style={{ minWidth: 0 }}>
                  <CardItem className="nameClients" style={{ margin: 0 }}>
                    {props.tag.name}{' '}
                  </CardItem>
                </Grid>
                <Grid item>
                  <Link
                    style={{
                      fontWeight: 'bold',
                      textTransform: 'uppercase',
                    }}
                    onClick={() => tagDetail()}
                  >
                    Ver detalhes <i className="fas fa-chevron-right" />
                  </Link>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Card>
      </Grid>
    </Grid>
  );
}
